module.exports = __webpack_public_path__ + "static/img/48492.cf3f5f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/48492.jpg
// module id = 65fd
// module chunks = 1